export default __webpack_public_path__ + "static/media/7.81bcae1c.png";